import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth';
import { AuthModel } from 'src/app/modules/auth/_models/auth.model';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-add-edit-survey',
  templateUrl: './add-edit-survey.component.html',
  styleUrls: ['./add-edit-survey.component.scss']
})
export class AddEditSurveyComponent implements OnInit {

  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  language: any;
  VisitId:any;
  Sections:any[]=[];
  SectionsResult:any[]=[];
  sectionsForm: FormGroup;

  constructor(private fb: FormBuilder,private HospitalService: HospitalService,private route: ActivatedRoute, private router: Router,
    private translationService: TranslationService, private auth: AuthService, private toast: HotToastService) {
  }
  ngOnInit(): void {
    this.VisitId = this.route.snapshot.params['visitId'];
    this.GetSurveyResult();
    this.language = this.translationService.getSelectedLanguage();
    this.isLoading$ = this.HospitalService.isLoading$;
    this.LoadForm();
  }
  LoadAllSections()
  {
    const sb = this.HospitalService.GetAllSurveySectionByVisitType(this.VisitId).subscribe(res => {
      if (res.data != null && res.isSuccess) {
        this.Sections = res.data;
        this.sectionsForm = this.fb.group({
          sections: this.fb.array(this.Sections.map(section => this.createSection(section))),
          VisitId:this.VisitId,
          Notes:['',[Validators.maxLength(3000),Validators.pattern('^[a-zA-Z0-9\u0621-\u064A ]+$')]],
        });
      }
    });
    this.subscriptions.push(sb);
    
  }
  GetSurveyResult()
  {
    const sb = this.HospitalService.GetSurveyResultByID(this.VisitId).subscribe(res => {
      if (res.data != null && res.isSuccess) {
        this.SectionsResult = res.data.sections;
        this.sectionsForm = this.fb.group({
          sections: this.fb.array(this.SectionsResult.map(section => this.createSection(section))),
          VisitId:this.VisitId,
          Notes:[res.data.notes,[Validators.maxLength(4000),Validators.pattern('^[a-zA-Z0-9\u0621-\u064A ]+$')]],
        });
      }
      else
      {
        this.LoadAllSections();

      }
    });
    this.subscriptions.push(sb);
    
  }
  LoadForm()
  {
    this.sectionsForm = this.fb.group({
      sections: this.fb.array(this.Sections.map(section => this.createSection(section))),
      VisitId:this.VisitId,
      Notes:['',[Validators.maxLength(3000),Validators.pattern('^[a-zA-Z0-9\u0621-\u064A ]+$')]],
    });
  }
  createSection(section): FormGroup {
    return this.fb.group({
      sectionTitle: this.language =='en' ? section.nameEn : section.nameAr,
      questions: this.fb.array(section.apiSurveyQuestions.map(question => this.createQuestion(question))),
      ApiSurveySectionId:section.id
    });
  }

  createQuestion(question): FormGroup {
    return this.fb.group({
      questionText:  this.language =='en' ? question.nameEn : question.nameAr,
      answer: question.answer,
      ApiSurveyQuestionId: question.id
    });
  }
 

  get sections() {
    return this.sectionsForm.get('sections') as FormArray;
  }

  getQuestions(sectionIndex: number): FormArray {
    return this.sections.at(sectionIndex).get('questions') as FormArray;
  }

  setAnswer(sectionIndex: number, questionIndex: number, answer: number) {
    this.getQuestions(sectionIndex).at(questionIndex).get('answer').setValue(answer);
  }

  onSubmit() {
    this.sectionsForm.markAllAsTouched();
    if (!this.sectionsForm.valid) {
      return;
    }
    this.HospitalService.showLoader();
    const Subscr = this.HospitalService.AddEditSurveyResult(this.sectionsForm.value).pipe(
      catchError((errorMessage) => {
        this.HospitalService.hideLoader();
        return of(errorMessage);
      })
    ).subscribe(res => {
      if (res.isSuccess && res.responseCode == 200) { 
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.HospitalService.hideLoader();
        setTimeout(() => {
          this.router.navigate(['/' ])
        }, 1000);

      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.HospitalService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.HospitalService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.HospitalService.hideLoader();

      }
    });
    this.subscriptions.push(Subscr);
  }
  isControlValid(controlName: string): boolean {
    const control = this.sectionsForm.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.sectionsForm.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string) {
    const control = this.sectionsForm.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string): boolean {
    const control = this.sectionsForm.controls[controlName];
    return control.dirty || control.touched;
  }
}
